import { SCHEDULING_FIELD_OPTIONS } from '../../constants';

// =============================================================================
// HELPER: Extract available fields from flow nodes for API body builder
// =============================================================================
const getAvailableFields = (nodes) => {
  const groups = [];

  // 1. Campos de data_collection (required_fields + optional_fields)
  const collectionFields = [];
  (nodes || []).forEach(n => {
    if (n.data?.key === 'data_collection' || n.data?.key === 'collect_data') {
      const cfg = n.data?.config || {};
      (cfg.required_fields || []).forEach(f => {
        if (!collectionFields.find(x => x.value === f)) {
          const label = SCHEDULING_FIELD_OPTIONS
            .flatMap(g => g.options)
            .find(o => o.value === f)?.label || f;
          collectionFields.push({ value: f, label });
        }
      });
      (cfg.optional_fields || []).forEach(f => {
        if (!collectionFields.find(x => x.value === f)) {
          const label = SCHEDULING_FIELD_OPTIONS
            .flatMap(g => g.options)
            .find(o => o.value === f)?.label || f;
          collectionFields.push({ value: f, label });
        }
      });
    }
  });
  if (collectionFields.length > 0) {
    groups.push({ label: 'Campos de Coleta', options: collectionFields });
  }

  // 2. Campos de collect_field (ações individuais)
  const collectFieldActions = [];
  (nodes || []).forEach(n => {
    if (n.data?.key === 'collect_field') {
      const fieldName = n.data?.config?.field_name;
      if (fieldName && !collectFieldActions.find(x => x.value === fieldName)) {
        const label = SCHEDULING_FIELD_OPTIONS
          .flatMap(g => g.options)
          .find(o => o.value === fieldName)?.label || fieldName;
        collectFieldActions.push({ value: fieldName, label });
      }
    }
  });
  if (collectFieldActions.length > 0) {
    groups.push({ label: 'Campos Individuais', options: collectFieldActions });
  }

  // 3. Variáveis customizadas (set_variable)
  const customVars = [];
  (nodes || []).forEach(n => {
    if (n.data?.key === 'set_variable') {
      const varName = n.data?.config?.variable;
      if (varName && !customVars.find(x => x.value === varName)) {
        customVars.push({ value: varName, label: varName });
      }
    }
  });
  if (customVars.length > 0) {
    groups.push({ label: 'Variáveis', options: customVars });
  }

  // 4. Dados de contexto fixos
  groups.push({
    label: 'Contexto',
    options: [
      { value: 'client_name', label: 'Nome do cliente' },
      { value: 'phone', label: 'Telefone do cliente' },
    ]
  });

  // 5. Se tem scheduling, adicionar campos de agendamento
  const hasScheduling = (nodes || []).some(n =>
    n.data?.key === 'scheduling' || n.data?.key === 'schedule'
  );
  if (hasScheduling) {
    groups.push({
      label: 'Agendamento',
      options: [
        { value: 'appointment_date', label: 'Data do agendamento' },
        { value: 'appointment_time', label: 'Horário do agendamento' },
        { value: 'professional_name', label: 'Profissional' },
      ]
    });
  }

  return groups;
};

export default getAvailableFields;
